import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';
import StatusInputs from '~/components/Forms/StatusInputs';
import type { PublicationForm } from '~/interfaces/form';
import type { Publication } from '~/interfaces/publication';

import FormHeader from './FormHeader';
import FormQuestions from './FormQuestions';

interface Props {
  email: string;
  form: PublicationForm;
  publication: Publication;
  isSubmitting: boolean;
  isPreview?: boolean;
  onPreviewSubmit?: () => void;
}

const FormBody = ({ email, publication, form, isSubmitting, isPreview = false, onPreviewSubmit }: Props) => {
  const { t } = useTranslation();
  const ctaText = form.cta_text || t('shared.cta.submit');

  return (
    <div className="space-y-8">
      {/* Form Titles */}
      <FormHeader name={publication.name} title={form.title} description={form.description} />

      {/* Form Body */}
      <div>
        <input name="email" type="hidden" value={email} />
        <input name="form_id" type="hidden" value={form.id} />
        <input name="publication_id" type="hidden" value={publication.id} />
        <StatusInputs name="no_subscription" errorMessage={t('forms.toast.no_subscription')} successMessage={''} />
        <StatusInputs
          name="form_response"
          errorMessage={t('errors.default')}
          successMessage={t('forms.toast.success')}
        />
        <FormQuestions questions={form.form_questions} />
      </div>

      {/* Form Submission */}
      <div className="flex w-full justify-between">
        {isPreview ? (
          <Button type="button" variant="primary" onClick={onPreviewSubmit} disabled={isSubmitting}>
            {isSubmitting ? `${t('shared.actions.submitting')}...` : ctaText}
          </Button>
        ) : (
          <Button type="submit" variant="primary" disabled={isSubmitting}>
            {isSubmitting ? `${t('shared.actions.submitting')}...` : ctaText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default FormBody;
